import { css, Interpolation, Theme } from '@emotion/react'
import { getColorOptions } from 'theme/utils'

export const wrapper: Interpolation<Theme> = css`
  width: 100%;
  padding: 0 24px 24px;
  box-sizing: border-box;
`

export const mainTitle: Interpolation<Theme> = (theme) => css`
  height: 90px;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: ${theme.typographyColors.typographyTwo};
  margin: 8px 0 16px;
`

export const contentWrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  gap: 24px;

  ${theme.breakpoints.down(900)} {
    flex-direction: column-reverse;
  }
`

export const content: Interpolation<Theme> = css`
  width: 100%;
  overflow: hidden;
`

export const templateName: Interpolation<Theme> = (theme: Theme) => css`
  margin-bottom: ${theme.spacing(3)};
`

export const selectsWrapper: Interpolation<Theme> = (theme) => css`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
  margin-top: 24px;

  div {
    overflow: hidden;
  }

  ${theme.breakpoints.down(650)} {
    grid-template-columns: 1fr;
  }
`

export const title: Interpolation<Theme> = (theme) => css`
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: ${theme.typographyColors.typographyTwo};
  margin: 30px 0 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid ${theme.backgrounds.backgroundOne};
`

export const note: Interpolation<Theme> = (theme) => css`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 24px;
  padding: 8px 12px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: 16px;
`

export const sourcesAndCreditsWrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;

  label {
    margin: 0;
  }
`

export const blocksWrapper: Interpolation<Theme> = (theme) => css`
  min-width: 268px;
  width: 268px;
  display: flex;
  flex-direction: column;
  gap: 15px;

  ${theme.breakpoints.down(900)} {
    width: 100%;
  }
`

export const block: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: column;
  padding: 14px;
  gap: 14px;
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 14px;

  h4 {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.typographyColors.typographyTwo};
    margin: 0;
  }
`

export const badge = (color: string) => css`
  box-sizing: border-box;
  width: fit-content;
  padding: 10px;
  gap: 5px;
  border-radius: 8px;
  font-weight: 700;
  line-height: 22px;
  background: ${getColorOptions(color).secondary};
  backdrop-filter: blur(7.5px);
  color: ${color};
`

export const checkbox: Interpolation<Theme> = (theme) => css`
  margin: 0;

  .MuiTypography-root {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.typographyColors.typographyThree};
    margin-left: 8px;
    user-select: none;
  }
`

export const questionLocations: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    line-height: 18px;
  }
`

export const empty: Interpolation<Theme> = (theme) => css`
  color: ${theme.typographyColors.typographyThree};
`
